import {
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES,
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_SUCCESS,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_FAIL,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  GET_NEWRELIC_ALERTS,
  GET_NEWRELIC_ALERTS_FAIL,
  GET_NEWRELIC_ALERTS_SUCCESS,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_SUCCESS,
  GET_NEWRELIC_RESOURCE_BY_ID,
  GET_NEWRELIC_RESOURCE_BY_ID_FAIL,
  GET_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  POST_NEW_RELIC_DISABLE_ALERTS,
  POST_NEW_RELIC_DISABLE_ALERTS_SUCCESS,
  POST_NEW_RELIC_DISABLE_ALERTS_FAIL,
  POST_NEW_RELIC_ENABLE_ALERTS,
  POST_NEW_RELIC_ENABLE_ALERTS_SUCCESS,
  POST_NEW_RELIC_ENABLE_ALERTS_FAIL,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  POST_NEW_RELIC_SERVICE_MAPPING,
  POST_NEW_RELIC_SERVICE_MAPPING_FAIL,
  POST_NEW_RELIC_SERVICE_MAPPING_SUCCESS,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_FAIL,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_COUNT_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_COUNT_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_COUNT,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_SUCCESS,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_FAIL,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION_SUCCESS,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION_FAIL,
  GET_NEWRELIC_TRANSACTIONS_BY_APM,
  GET_NEWRELIC_TRANSACTIONS_BY_APM_SUCCESS,
  GET_NEWRELIC_TRANSACTIONS_BY_APM_FAIL,
  GET_NEWRELIC_EXTERNAL_SERVICES,
  GET_NEWRELIC_EXTERNAL_SERVICES_FAIL,
  GET_NEWRELIC_EXTERNAL_SERVICES_SUCCESS,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_SUCCESS,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_FAIL,
  GET_USER_RESCAN_STATUS_NEWRELIC,
  GET_USER_RESCAN_STATUS_NEWRELIC_SUCCESS, GET_USER_RESCAN_STATUS_NEWRELIC_FAIL,
} from "./actionTypes";

export const getNewRelicAllResourceAlerts = () => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS,
})

export const getNewRelicAllResourceAlertsSuccess = newrelic_all_resource_alerts => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS_SUCCESS,
  payload: newrelic_all_resource_alerts,
})

export const getNewRelicAllResourceAlertsFail = error => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS_FAIL,
  payload: error,
})

export const getNewRelicAllResourceAlertsPage = (page_filters) => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE,
  payload: { page_filters }
})

export const getNewRelicAllResourceAlertsPageSuccess = newrelic_all_resource_alerts => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  payload: newrelic_all_resource_alerts,
})

export const getNewRelicAllResourceAlertsPageFail = error => ({
  type: GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  payload: error,
})

export const getNewRelicExternalServices = (page_filters) => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES,
    payload: { page_filters }
})

export const getNewRelicExternalServicesSuccess = newrelic_external_services => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES_SUCCESS,
    payload: newrelic_external_services,
})

export const getNewRelicExternalServicesFail = error => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES_FAIL,
    payload: error,
})

export const getNewRelicResourceCount = (page_filters) => ({
  type: GET_NEWRELIC_ALL_RESOURCE_COUNT,
  payload: { page_filters }
})

export const getNewRelicResourceCountSuccess = newrelic_all_resource_count => ({
  type: GET_NEWRELIC_ALL_RESOURCE_COUNT_SUCCESS,
  payload: newrelic_all_resource_count,
})

export const getNewRelicResourceCountFail = error => ({
  type: GET_NEWRELIC_ALL_RESOURCE_COUNT_FAIL,
  payload: error,
})

export const getNewRelicExternalServicesResourceCount = (page_filters) => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT,
    payload: { page_filters }
})

export const getNewRelicExternalServicesResourceCountSuccess = newrelic_external_services_count => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_SUCCESS,
    payload: newrelic_external_services_count,
})

export const getNewRelicExternalServicesResourceCountFail = error => ({
    type: GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_FAIL,
    payload: error,
})

export const getAllOrgNewRelicResourceTypes = () => ({
  type: GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES
})

export const getAllOrgNewRelicResourceTypesSuccess = orgNewRelicResourceTypes => ({
  type: GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_SUCCESS,
  payload: orgNewRelicResourceTypes,
})

export const getAllOrgNewRelicResourceTypesFail = error => ({
  type: GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_FAIL,
  payload: error,
})

export const getNRResourceByResourceID = data => ({
  type: GET_NEWRELIC_RESOURCE_BY_ID,
  payload: data
})

export const getNRResourceByResourceIDSuccess = aws_resource => ({
  type: GET_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  payload: aws_resource,
})

export const getNRResourceByResourceIDFail = error => ({
  type: GET_NEWRELIC_RESOURCE_BY_ID_FAIL,
  payload: error,
})

export const getDefaultThresholdsNRResourceByResourceID = data => ({
  type: GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID,
  payload: data
})

export const getDefaultThresholdsNRResourceByResourceIDSuccess = default_threshold_newRelic_resource => ({
  type: GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  payload: default_threshold_newRelic_resource,
})

export const getDefaultThresholdsNRResourceByResourceIDFail = error => ({
  type: GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_FAIL,
  payload: error,
})

export const onPostNewRelicResourceOpsgenieTeamMapping = newrelic_resource_team_mapping => {
  return {
    type: POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { newrelic_resource_team_mapping }
  }
}

export const onPostNewRelicResourceOpsgenieTeamMappingSuccess = new_relic_resources => ({
  type: POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  payload: new_relic_resources,
})

export const onPostNewRelicResourceOpsgenieTeamMappingFail = error => ({
  type: POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  payload: error,
})

export const postNewRelicResourcePagerdutyServiceMapping = newrelic_resource_pagerduty_mapping => {
  return {
    type: POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: { newrelic_resource_pagerduty_mapping }
  }
}

export const onPostNewRelicResourcePagerdutyServiceMappingSuccess = new_relic_resources => ({
  type: POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  payload: new_relic_resources,
})

export const onPostNewRelicResourcePagerdutyServiceMappingFail = error => ({
  type: POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  payload: error,
})

export const postNewRelicServiceMapping = (service_mapping) => {
  return {
    type: POST_NEW_RELIC_SERVICE_MAPPING,
    payload: { service_mapping }
  }
}

export const postNewRelicServiceMappingFail = error => ({
  type: POST_NEW_RELIC_SERVICE_MAPPING_FAIL,
  payload: error,
})

export const postNewRelicServiceMappingSuccess = new_relic_resources => ({
  type: POST_NEW_RELIC_SERVICE_MAPPING_SUCCESS,
  payload: new_relic_resources,
})

export const postUpdateNewRelicResourceEnvironment = resource_environment => {
  return {
    type: POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT,
    payload: { resource_environment }
  }
}

export const postUpdateNewRelicResourceEnvironmentSuccess = cloudResources => ({
  type: POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_SUCCESS,
  payload: cloudResources,
})

export const postUpdateNewRelicResourceEnvironmentFail = error => ({
  type: POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_FAIL,
  payload: error,
})

export const postNewRelicDisableAlerts = (alerts) => {
  return {
    type: POST_NEW_RELIC_DISABLE_ALERTS,
    payload: { alerts }
  }
}

export const postNewRelicDisableAlertsSuccess = (alerts) => {
  return {
    type: POST_NEW_RELIC_DISABLE_ALERTS_SUCCESS,
    payload: { alerts }
  }
}

export const postNewRelicEnableAlerts = (alerts) => {
  return {
    type: POST_NEW_RELIC_ENABLE_ALERTS,
    payload: { alerts }
  }
}

export const postNewRelicEnableAlertsSuccess = (alerts) => {
  return {
    type: POST_NEW_RELIC_ENABLE_ALERTS_SUCCESS,
    payload: { alerts }
  }
}

export const postNewRelicEnableAlertsFail = error => ({
  type: POST_NEW_RELIC_ENABLE_ALERTS_FAIL,
  payload: error,
})

export const postNewRelicDisableAlertsFail = error => ({
  type: POST_NEW_RELIC_DISABLE_ALERTS_FAIL,
  payload: error,
})

export const getNewRelicAlerts = (data) => ({
  type: GET_NEWRELIC_ALERTS,
  payload: data,
})

export const getNewRelicAlertsSuccess = new_relic_alerts => ({
  type: GET_NEWRELIC_ALERTS_SUCCESS,
  payload: new_relic_alerts,
})

export const getNewRelicAlertsFail = error => ({
  type: GET_NEWRELIC_ALERTS_FAIL,
  payload: error,
})

export const getNewRelicDynamicAlertsDeployedByResourceID = data => ({
  type: GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  payload: data,
})

export const getNewRelicDynamicAlertsDeployedByResourceIDSuccess = new_relic_dynamic_alerts => ({
  type: GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  payload: new_relic_dynamic_alerts,
})

export const getNewRelicDynamicAlertsDeployedByResourceIDFail = error => ({
  type: GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getNewRelicMissingDynamicAlertsByResourceID = data => ({
  type: GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  payload: data,
})

export const getNewRelicMissingDynamicAlertsByResourceIDSuccess = new_relic_missing_dynamic_alerts => ({
  type: GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: new_relic_missing_dynamic_alerts,
})

export const getNewRelicMissingDynamicAlertsByResourceIDFail = error => ({
  type: GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const deployNewRelicDynamicAlertsByResourceID = data => ({
  type: DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  payload: data,
})

export const deployNewRelicDynamicAlertsByResourceIDSuccess = new_relic_dynamic_alerts => ({
  type: DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: new_relic_dynamic_alerts,
})

export const deployNewRelicDynamicAlertsByResourceIDFail = error => ({
  type: DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const onPostNewRelicTransactionAsKeyTransaction = payload => ({
  type: POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION,
  payload: payload
});

export const onPostNewRelicTransactionAsKeyTransactionSuccess = (data) => ({
  type: POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_SUCCESS,
  payload: data
})

export const onPostNewRelicTransactionAsKeyTransactionFail = error => ({
  type: POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_FAIL,
  payload: error
})

export const onPostNewRelicDeleteKeyTransaction = payload => ({
  type: POST_NEWRELIC_DELETE_KEY_TRANSACTION,
  payload: payload
});

export const onPostNewRelicDeleteKeyTransactionSuccess = (data) => ({
  type: POST_NEWRELIC_DELETE_KEY_TRANSACTION_SUCCESS,
  payload: data
})

export const onPostNewRelicDeleteKeyTransactionFail = error => ({
  type: POST_NEWRELIC_DELETE_KEY_TRANSACTION_FAIL,
  payload: error
})

export const onGetNewRelicTransactionByAPM = (page_filters) => ({
  type: GET_NEWRELIC_TRANSACTIONS_BY_APM,
  payload:{page_filters}
});

export const onGetNewRelicTransactionByAPMSuccess = payload => ({
  type: GET_NEWRELIC_TRANSACTIONS_BY_APM_SUCCESS,
  payload: payload
});

export const onGetNewRelicTransactionByAPMFail = payload => ({
  type: GET_NEWRELIC_TRANSACTIONS_BY_APM_FAIL,
  payload: payload
});


export const getNewRelicRefreshScanStatus = () => ({
  type: GET_USER_RESCAN_STATUS_NEWRELIC,
})

export const getNewRelicRefreshScanStatusSuccess = new_relic_refresh_status => ({
  type: GET_USER_RESCAN_STATUS_NEWRELIC_SUCCESS,
  payload: new_relic_refresh_status,
})

export const getNewRelicRefreshScanStatusFail = error => ({
  type: GET_USER_RESCAN_STATUS_NEWRELIC_FAIL,
  payload: error,
})



